export const formatMonth = (date: Date): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);
  return `${month}-${year}`;
};

export const getCurrentMonth = (): string => {
  return formatMonth(new Date());
};

export const getLastMonth = (): string => {
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return formatMonth(lastMonth);
};

export const getFinancialYearStartMonthIndex = (fyStartMonth: string): number => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const fyStartMonthIndex = months.indexOf(fyStartMonth);
  if (fyStartMonthIndex === -1) {
    // Default to January if not found
    return 0;
  }
  return fyStartMonthIndex;
};

export const getCurrentFinancialYearStart = (fyStartMonth?: string): string => {
  const now = new Date();
  const fyStartMonthIndex = getFinancialYearStartMonthIndex(fyStartMonth ?? 'Jan');

  const fyStartDate =
    now.getMonth() >= fyStartMonthIndex
      ? new Date(now.getFullYear(), fyStartMonthIndex, 1)
      : new Date(now.getFullYear() - 1, fyStartMonthIndex, 1);

  return formatMonth(fyStartDate);
};

export const getReportingPeriodDisplay = (
  dashboardReportingPeriod: any,
  fy_start_month: string | undefined,
  preset: string = 'Custom',
) => {
  let dateRange = '';

  switch (preset) {
    case 'Custom':
      if (dashboardReportingPeriod?.start && dashboardReportingPeriod?.end) {
        dateRange = ` (${dashboardReportingPeriod.start} - ${dashboardReportingPeriod.end})`;
      }
      break;
    case 'Current Month': {
      const currentMonth = getCurrentMonth();
      dateRange = ` (${currentMonth})`;
      break;
    }
    case 'Last Month': {
      const lastMonth = getLastMonth();
      dateRange = ` (${lastMonth})`;
      break;
    }
    case 'Financial Year to Last Month': {
      const fyStartMonth = fy_start_month as string | undefined;
      const fyStart = getCurrentFinancialYearStart(fyStartMonth);
      const lastMonth = getLastMonth();
      dateRange = ` (${fyStart} - ${lastMonth})`;
      break;
    }
    case 'This Financial Year': {
      const fyStartMonth = fy_start_month as string | undefined;
      const fyStart = getCurrentFinancialYearStart(fyStartMonth);
      const currentMonth = getCurrentMonth();
      dateRange = ` (${fyStart} - ${currentMonth})`;
      break;
    }
    default:
      break;
  }

  return `${preset}${dateRange}`;
};
